import React from 'react';
import { howItWorksSteps } from '../data/mock';
import { Search, Layers, Code2, Rocket } from 'lucide-react';

const iconMap = {
  'search': Search,
  'layers': Layers,
  'code-2': Code2,
  'rocket': Rocket
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 bg-[#0B0F14] relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-white font-['Qurova',sans-serif]">
            How We <span className="text-[#3DF2E0]">Work</span>
          </h2>
          <p className="text-xl text-[#9CA3AF] font-['League_Spartan'] max-w-2xl mx-auto">

          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 gap-8">
          {howItWorksSteps.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.id} className="relative group">
                {/* Connector Line */}
                {index < howItWorksSteps.length - 1 && (
                  <div className="hidden lg:block absolute left-full top-0 w-[180px] h-[120px] pointer-events-none">

                    {/* TOP ARROW (1→2 and 3→4) */}
                    {(index === 0 || index === 2) && (
                      <svg
                        className="absolute -top-24 -left-14 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        width="240"
                        height="160"
                        viewBox="0 0 240 160"
                        fill="none"
                      >

                        {/* hand drawn curve */}
                        <path
                          d="M0 120 
       C 40 40, 120 10, 190 70"
                          stroke="#3DF2E0"
                          strokeWidth="3"
                          strokeLinecap="round"
                        />

                        {/* arrow head (hand drawn style) */}
                        <g transform="rotate(35 195 72)">
                          <path
                            d="M188 60 L205 72 L188 84"
                            stroke="#3DF2E0"
                            strokeWidth="3"
                            strokeLinecap="round"
                            fill="none"
                          />
                        </g>

                      </svg>
                    )}

                    {/* BOTTOM ARROW (2→3) */}
                    {index === 1 && (
                      <svg
                        className="absolute top-[300px] -left-14 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        width="240"
                        height="160"
                        viewBox="0 0 240 160"
                        fill="none"
                      >

                        {/* bottom bow curve */}
                        <g transform="rotate(-8 195 65)">
                          <path
                            d="M0 20 C 60 120, 120 150, 200 70"
                            stroke="#3DF2E0"
                            strokeWidth="3"
                            strokeLinecap="round"
                          />

                          {/* arrow head */}
                          <g transform="rotate(-35 205 70)">
                            <path
                              d="M198 60 L215 70 L198 82"
                              stroke="#3DF2E0"
                              strokeWidth="3"
                              strokeLinecap="round"
                              fill="none"
                            />
                          </g>
                        </g>

                      </svg>
                    )}

                  </div>
                )}

                {/* Step Card */}
                <div className="relative z-10 bg-[#0B0F14] border border-[#1F2933] rounded-md p-6 hover:border-[#3DF2E0] transition-all duration-300 h-full">
                  {/* Step Number */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 rounded-md border border-[#3DF2E0] flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-[#3DF2E0]" />
                    </div>
                    <div className="text-4xl font-bold text-[#1F2933] font-['JetBrains_Mono',monospace] group-hover:text-[#3DF2E0] transition-colors duration-300">
                      0{step.id}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="space-y-2">
                    <h3 className="text-lg font-semibold text-white font-['Qurova',sans-serif]">
                      {step.title}
                    </h3>
                    <p className="text-lg text-[#9CA3AF] font-['League_Spartan'] leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
